class ProductPatchSpecs extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    const shapeGroup = /** @type {HTMLElement | null} */ (this.querySelector('[ref="shapeGroup"]'));
    const shapeTypeInputs = /** @type {NodeListOf<HTMLInputElement>} */ (
      this.querySelectorAll('input[data-toggles-shape]')
    );

    const syncShapeVisibility = () => {
      if (!shapeGroup) return;
      const checked = Array.from(shapeTypeInputs).find((input) => input.checked);
      const isRegular = checked ? checked.dataset.togglesShape === 'true' : true;
      shapeGroup.hidden = !isRegular;
      const shapeInputs = shapeGroup.querySelectorAll('input[type="radio"]');
      shapeInputs.forEach((input) => {
        if (input instanceof HTMLInputElement) input.disabled = !isRegular;
      });
    };

    shapeTypeInputs.forEach((input) => {
      input.addEventListener('change', syncShapeVisibility, { signal });
    });

    syncShapeVisibility();

    // Artwork gating: hide until a file has been uploaded in the page's
    // product-artwork-upload component. Listens for the event it dispatches.
    if (this.dataset.gateOnArtwork === 'true') {
      this.#applyGate(false);
      const formId = this.dataset.formId || null;
      document.addEventListener(
        'artwork-upload:change',
        (event) => {
          const detail = /** @type {CustomEvent} */ (event).detail;
          if (!detail) return;
          if (formId && detail.formId && detail.formId !== formId) return;
          this.#applyGate(Boolean(detail.hasFile));
        },
        { signal }
      );
    }
  }

  /**
   * Toggles the block's visibility and disables/enables form-attached inputs
   * so required validation doesn't fire while the block is hidden.
   * @param {boolean} hasFile
   */
  #applyGate(hasFile) {
    this.hidden = !hasFile;
    const inputs = this.querySelectorAll('input, select, textarea');
    inputs.forEach((el) => {
      if (
        el instanceof HTMLInputElement ||
        el instanceof HTMLSelectElement ||
        el instanceof HTMLTextAreaElement
      ) {
        if (hasFile) {
          if (el.dataset.artworkGated === 'true') {
            el.disabled = false;
            delete el.dataset.artworkGated;
          }
        } else if (!el.disabled) {
          el.disabled = true;
          el.dataset.artworkGated = 'true';
        }
      }
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }
}

if (!customElements.get('product-patch-specs')) {
  customElements.define('product-patch-specs', ProductPatchSpecs);
}
